import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';


loadFonts()

import * as generalFunctions from './utilities/generalFunctions.js';
import * as displayFunctions from './utilities/displayFunctions.js';
import * as localStorageFunctions from './utilities/localStorageFunctions';
import * as assets from './utilities/assets';

document.addEventListener('click', () => {
  document.body.setAttribute('data-user-interacted', 'true');
}, { once: true });



import { SafeArea } from 'capacitor-plugin-safe-area';

SafeArea.getSafeAreaInsets().then(({ insets }) => {
  for (const [key, value] of Object.entries(insets)) {
    document.documentElement.style.setProperty(
      `--safe-area-inset-${key}`,
      `${value}px`,
    );
  }
});


await SafeArea.removeAllListeners();

// when safe-area changed
await SafeArea.addListener('safeAreaChanged', data => {
  const { insets } = data;
  for (const [key, value] of Object.entries(insets)) {
    document.documentElement.style.setProperty(
      `--safe-area-inset-${key}`,
      `${value}px`,
    );
  }
});

const app = createApp(App);
app.provide('$generalFunctions', generalFunctions);
app.provide('$displayFunctions', displayFunctions);
app.provide('$localStorageFunctions', localStorageFunctions);
app.provide('$assets', assets);
app.use(router)
app.use(vuetify)
app.component('QuillEditor', QuillEditor)
app.mount('#app')